// Some backend integrations pass a third-party API's raw error body straight through as the
// `message` string instead of extracting their own human-readable text — e.g. Salto Space SHIP
// errors like `{"Code":"12","Message":"Start date/time bigger than end date/time"}`. Detect that
// shape and surface the embedded message instead of the raw JSON blob.
export const unwrapEmbeddedErrorMessage = (message: string): string => {
  const trimmed = message.trim()
  if (!trimmed.startsWith('{')) return message

  try {
    const parsed: unknown = JSON.parse(trimmed)
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      'Message' in parsed &&
      typeof (parsed as { Message?: unknown }).Message === 'string'
    ) {
      return (parsed as { Message: string }).Message
    }
  } catch {
    /* not JSON - leave the original message as-is */
  }

  return message
}
